import { render } from "./ParticipationsList.vue?vue&type=template&id=17808576&ts=true"
import script from "./ParticipationsList.vue?vue&type=script&lang=ts"
export * from "./ParticipationsList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__